var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFlipIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 235,
    height: 226,
    viewBox: "0 0 235 226",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M217.658 96.8628H221.945C228.654 96.8628 234.051 91.4658 234.051 84.7574V20.1951C234.051 15.3025 231.125 10.8638 226.586 8.99757C222.046 7.13131 216.851 8.1401 213.371 11.6204L192.388 32.6032C148.203 -11.0268 77.0334 -10.8755 33.1008 33.1075C-11.0336 77.2419 -11.0336 148.765 33.1008 192.899C77.2352 237.034 148.758 237.034 192.892 192.899C199.197 186.594 199.197 176.355 192.892 170.05C186.588 163.745 176.348 163.745 170.043 170.05C138.519 201.575 87.4239 201.575 55.8993 170.05C24.3748 138.526 24.3748 87.4307 55.8993 55.9061C87.2726 24.5329 137.964 24.3816 169.539 55.4017L148.809 76.1827C145.328 79.663 144.319 84.8583 146.186 89.3978C148.052 93.9373 152.491 96.8628 157.383 96.8628H217.658Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlipIcon);
export default __webpack_public_path__ + "static/media/flip-icon.24d6a6f06d1ba9133dfc52bd88a84086.svg";
export { ForwardRef as ReactComponent };